module.exports = __webpack_public_path__ + "static/media/record.f4c7e26a.svg";